// hooks/ConfirmProvider.tsx
import type { ReactNode } from "react"
import { use } from "react"
import { ConfirmContext } from "./confirm-context"

export function useConfirm() {
  const ctx = use(ConfirmContext)
  if (!ctx)
    throw new Error("useConfirm must be used within ConfirmProvider")
  return ctx
}

export type ConfirmOptions = {
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
  content?: ReactNode
}

export type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>
